/**
 * Created by neo on 15.01.17.
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { Audited, createAuditedFields } from './Audited';
import { Gym, GymApi } from './Gym/Gym';
import { Athlete } from './Athlete/Athlete';
import { HttpBackend } from '../Services/Http/HttpBackend';

export type Customer = Audited & {
  gymId: string;
  athlete: Athlete;
  status: string;
  gym?: Gym;
  save(): Promise<any>;
  remove(): Promise<any>;
};

export function createCustomer(json?: Partial<Customer>): Customer {
  const base = createAuditedFields(json);
  return makeAutoObservable({
    ...base,
    id: json?.id || UUID(),
    gymId: json?.gymId ?? '',
    athlete: (json?.athlete ?? { id: '', createdAt: '', updatedAt: '', user: { id: '', email: '', roles: [], createdAt: '', updatedAt: '' }, gender: 'UNKNOWN', tags: [], allowsDataSharing: false, acceptsMarketing: false }) as Athlete,
    status: json?.status ?? '',
    gym: undefined as Gym | undefined,

    save() {
      return HttpBackend.post('/athlete', this.athlete);
    },

    remove() {
      return HttpBackend.delete(`/gym/customer/${this.id}`);
    },
  });
}

export const CustomerApi = {
  recentCoachCustomer(): Promise<Customer | undefined> {
    return HttpBackend.get(`/gym/customer/recentCoachCustomer`).then((res) => (res ? createCustomer(res) : undefined));
  },

  find(data: any = { start: 0, sort: 'athlete.firstname,ASC' }): Promise<Customer[]> {
    return HttpBackend.get(`/gym/customer`, data).then((res) => (res ?? []).map((c: any) => createCustomer(c)));
  },

  count(data: any = { start: 0, sort: 'athlete.firstname,ASC' }): Promise<number> {
    return HttpBackend.get(`/gym/customer/count`, data).then((res) => res ?? 0);
  },
};
